module.exports = __webpack_public_path__ + "common/icon-app-estimate-b599e79762b39b9bc6398efb12704a4c.svg";